module.exports = __webpack_public_path__ + "cef6984c179003ea7289585f53ec3953.fbx";